'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import appConstants from 'constants/appConstants';

import personActions from 'actions/PersonActionCreators';
import personStore from 'stores/PersonStore';
import PageSection from 'components/base/PageSection';
import WidgetProfile from 'components/base/WidgetProfile';

import _ from 'underscore';
import utils from 'services/utils';
import constants from 'constants/appConstants';
import moment from 'moment';
import personUtils from 'services/people/personUtils';

const propTypes = {
    error: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
};

class ProfileWidget extends React.Component {
    
    constructor(props) {
        super(props);
    }

    render() {

        var initialLoading = false;
        var content = "";
        var link = "";

        if (this.props.person) {
            content = <WidgetProfile person={this.props.person} />;
            link = "/members/" + this.props.person.Id + "/personal-information/";
        } else {
            initialLoading = true;
        }

        var style = null;
        if (this.props.person) {
            style = String(personUtils.getAvatarColour(this.props.person.Id));
        }

        return (
            
            <PageSection 
                id="profile-widget"
                halfSize={false}
                loading={initialLoading}
                backgroundColor={style}
                link={link}
            >
                {content}
            </PageSection>

        );
    }
}

ProfileWidget.propTypes = propTypes;

export default ProfileWidget; 